export * from './common'
export * from './form'
export * from './common/bankcardList'
export * from './common/fileUpload'
export * from './common/modal'
export * from './main'
export * from './products'
export * from './user'
export * from './applyLoan/step1'
export * from './personaCenter/myInfo'
export * from './personaCenter/updatePassword'
export * from './personaCenter/repaymentInfo'
export * from './personaCenter/loanLists'
export * from './personaCenter/loanDetail'
export * from './personaCenter/myLoan'
export * from './personaCenter/prepayment'
export * from './personaCenter/wholeRepay'
export * from './personaCenter/realNameAuth'



// WEBPACK FOOTER //
// ./src/vuex/types/index.js